<template>
  <div class="weightTracker">
    <AppHeader></AppHeader>
    <div class="page-wrapper">
      <div class="container-fluid">
        <!-- Title -->
        <div class="row heading-bg">
          <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
            <h5 class="txt-dark weightTitle">Weight Tracker</h5>
          </div>
        </div>
        <!-- /Title -->
        <div class="panel panel-default card-view panel-refresh">
          <div class="panel-heading">
            <div class="pull-left">
              <h6 class="panel-title txt-light">Weight Progress</h6>
            </div>
            <div class="pull-right">
              <a
                href="#"
                data-toggle="modal"
                data-target="#weightSettingsModal"
                ref="weightSettingsModalTrigger"
              >
                <i class="fa fa-cog"></i>
              </a>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <a
                href="#"
                data-toggle="modal"
                data-target="#weightTrackingModal"
                ref="trackWeightModalTrigger"
                class="btn btn-nutri-green"
              >Track New Weight</a>
            </div>
            <div class="clearfix"></div>
          </div>
          <div id="collapse_1" class="panel-wrapper collapse in">
            <div class="panel-body">
              <div class="col-sm-3 widget">
                <WeightStatusWidget :key="widgetKey"></WeightStatusWidget>
              </div>
              <div class="col-sm-6 progress-table">
                <div class="table-wrap">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0">
                      <thead>
                        <tr>
                          <th style="width:20%;">Photo</th>
                          <th>Date</th>
                          <th>Weight</th>
                          <th>Progress</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in weight_records" v-bind:key="index">
                          <td>
                            <div type="button" @click="pictureModal(record.photo)" class="btn btn-light mainphoto" data-toggle="modal" data-target="#ModalCenter"><img :src="record.photo ? record.photo : 'dist/img/nophoto.jpg'" alt="photo"></div>
														<!-- Modal -->
														<div class="modal fade" id="ModalCenter" tabindex="-1" role="dialog" aria-labelledby="ModalCenterTitle" ref="mainModal" aria-hidden="true">
															<div class="modal-dialog modal-dialog-centered" role="document">
																<div class="modal-content">
																<div class="modal-header">
																	<button type="button" class="close" data-dismiss="modal" aria-label="Close">
																	<span aria-hidden="true">&times;</span>
																	</button>
																</div>
																<div class="modal-body">
                                  <img style="height:100% !important;max-height:400px;" :src="modal_picture ? modal_picture : 'dist/img/nophoto.jpg'" alt="photo">
																</div>
																<div class="modal-footer">
																	<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
																</div>
																</div>
															</div>
														</div>
                          </td>
                          <td>{{record.date}}</td>
                          <td>{{record.weight}}</td>
                          <td>
                            <span
                              class="txt-success"
                              v-show="record.progress < 0 && record.progress != null"
                            >
                              <i class="zmdi zmdi-caret-down mr-10 font-20"></i>
                              <span>{{record.progress}}</span>
                            </span>
                            <span
                              class="txt-danger"
                              v-show="record.progress >= 0 && record.progress != null"
                            >
                              <i class="zmdi zmdi-caret-up mr-10 font-20"></i>
                              <span>{{record.progress}}</span>
                            </span>
                          </td>
                          <td>
                            <a
                              href="#"
                              class="trash"
                              title="Delete"
                              data-toggle="modal" @click="temp_id = record.id" data-target="#exampleModal"
                            >
                              <i style="font-size:25px !important;"  class="fa fa-trash"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <p v-if="weight_records.length == 0" style="padding-top:10px;text-align:center;">There are no records to show.</p>
              </div>

              <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Delete Record</h5>
                  </div>
                  <div class="modal-body">
                    Are you sure you want to delete this weight record?
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="deleteRecord(temp_id)">Okay</button>
                  </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 widget">
                <weight-progress-chart ref="chart" :key="chartKey"></weight-progress-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Weight Tracking Modal -->
    <div
      id="weightTrackingModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-header-icon">
              <img src="dist/img/icons/scale.jpg" alt="scale">
              <h4>Track your weight</h4>
              <br>
              <br>
              <form class="form-horizontal">
                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">Date</label>
                  <div class="col-sm-9">
                    <div class="input-group col-sm-12">
                      <datepicker inputClass="form-control" v-model="newWeightDate"></datepicker>
                      <!-- <datetime input-id="startDate" v-model="newWeightDate" inputClass="form-control">
                        <template slot="button-cancel">
                          <fa :icon="['far', 'times']"></fa>
                          Cancel
                        </template>
                        <template slot="button-confirm">
                          <fa :icon="['fas', 'check-circle']"></fa>
                          Confirm
                        </template>
                      </datetime> -->
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">Weight</label>
                  <div class="col-sm-9">
                    <div class="input-group col-sm-12">
                      <input
                        type="number"
                        class="form-control"
                        id="weight"
                        :placeholder="'Weight in ' + current_weight_units"
                        v-model="newWeightValue"
                      >
                      <span class="input-group-addon">{{current_weight_units}}</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">Progress Photo</label>
                  <div class="col-sm-9">
                    <div class="input-group col-sm-12">
                      <button type="button" @click="$refs.file.click()" class="btn btn-block btn-nutri-green">Upload Picture</button>
                      <input v-show="false" type="file" id="file" ref="file" v-on:change="handleFileUpload()">
                    </div>
                  </div>
                  <div class="col-sm-12" style="padding-top:20px;">
                    <img :src="newWeightPhoto" v-if="newWeightPhoto" alt="">
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-nutri-red"
              data-dismiss="modal"
              ref="weightTrackerClose"
            >Close</button>
            <button type="button" ref="weightTrackerTrack" class="btn btn-nutri-green" data-dismiss="modal" @click="addWeight">Track</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- Weight Settings Modal -->
    <div
      id="weightSettingsModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-header-icon">
              <img src="dist/img/icons/settings.png" alt="scale">
              <h4>Weight Tracking Settings</h4>
              <br>
              <br>
              <form class="form-horizontal">
                <div class="form-group">
                  <label for="goal" class="col-sm-3 control-label">Goal Weight</label>
                  <div class="col-sm-9">
                    <div class="input-group col-sm-12">
                      <input
                        type="number"
                        class="form-control"
                        id="weight"
                        :placeholder="'Weight in ' + current_weight_units"
                        v-model="newWeightGoal"
                      >
                      <span class="input-group-addon">{{current_weight_units}}</span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-nutri-red"
              data-dismiss="modal"
              ref="weightSettingsClose"
            >Close</button>
            <button type="button" class="btn btn-nutri-green" @click="updateWeightSettings">Update</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /Main Content -->
    <AppFooter></AppFooter>
    <loading :active.sync="isLoading"></loading>
  </div>
</template>

<script>
	import API from '../../services/api.js';
	import AppHeader from '../../components/common/AppHeader.vue'
	import AppFooter from '../../components/common/AppFooter.vue'
	import WeightProgressChart from '../../components/common/WeightProgressChart.vue'
	import WeightStatusWidget from '../../components/common/WeightStatusWidget.vue'
	import Datepicker from 'vuejs-datepicker';
  import swal from 'sweetalert';
  import Loading from 'vue-loading-overlay';
	// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
	import {
		mapMutations,
  } from 'vuex';
  import { Datetime } from 'vue-datetime'
	// You need a specific loader for CSS files
	import 'vue-datetime/dist/vue-datetime.css'
	const api = new API();

	export default {
		components: {
			AppHeader,
			AppFooter,
			WeightProgressChart,
			WeightStatusWidget,
			Datepicker,
      swal,
      Loading,
      Datetime,
		},
		props:[
			'date'
		],
		data() {
			return {
        isLoading: false,
				weight_records: [],
				newWeightDate: new Date(),
				newWeightPhoto: '',
				newWeightValue: this.$store.getters.user.weight,
				current_weight_units: this.$store.getters.user.meta_data.preferred_units == "metric" ? "kg" : "lbs",
				chartKey: "chart_" + Math.random(0, 100),
				widgetKey: "widget_" + Math.random(0, 100),
        newWeightGoal: null,
        modal_picture: "",
        temp_id: 0,
			}
		},
		created() {
			this.loadWeight();
		},
		mounted(){
			if(this.$route.query.tracking == 1){
				const elem = this.$refs.trackWeightModalTrigger;
				elem.click();
				this.$router.replace('/weight-tracker');
			}
		},
		watch:{
			date:function(){
				this.refreshComponents();
			}
		},
		methods: {
			updateWeightSettings(){
				api.updateProfile({
					"goal_weight" : this.newWeightGoal
				}).then(async response => {
					swal("Weight Settings Updated!", "", "success");
					const elem = this.$refs.weightSettingsClose;
					elem.click();
					this.refreshComponents();
				});
			},
			refreshComponents(){
					this.loadWeight();
					api.me();
					setTimeout(() => {
						this.chartKey = "chart_" + Math.random(0, 100);
						this.widgetKey = "widget_" + Math.random(0, 100);	
					}, (500));
			},
			deleteRecord(id) {
        this.isLoading = true;
				api.deleteProgress(id).then(async response => {
          this.isLoading = false;
					swal("Weight Record Deleted!", "", "success");
					this.refreshComponents();
				});
			},
			addWeight() {
        this.isLoading = true;
				api.addProgress("weight", this.newWeightDate, this.newWeightValue, this.newWeightPhoto).then(async response => {
          this.isLoading = false;
					const elem = this.$refs.weightTrackerClose;
          elem.click();
          this.newWeightPhoto = "";
					swal("Weight Tracked!", "", "success");
					this.refreshComponents();
				});
			},
			handleFileUpload() {
        const elem = this.$refs.weightTrackerClose;
        const elem2 = this.$refs.weightTrackerTrack;
        
        elem.disabled = true;
				elem2.disabled = true;

				api.uploadPhoto("weight",  this.$refs.file.files[0]).then(async response => {
					if (response.data.success) {
            this.newWeightPhoto = response.data.data;
            elem.disabled = false;
						elem2.disabled = false;
					}
				});
			},
			loadWeight() {
				api.getProgress("weight").then(response => {
					if (response.data.success) {
						this.weight_records = [];
						var progress_records = response.data.data;

						for (var p = 0; p < progress_records.length; p++) {
							var myDate = new Date(progress_records[p].date);
							var progress = null;

							if (p > 0) {
								progress = (parseFloat(parseFloat(this.$store.getters.user.meta_data.preferred_units == "metric" ? progress_records[p].value : progress_records[p].imperial_value) - parseFloat(this.weight_records[p - 1].weight))).toFixed(1);
							}

							var record = {
								id: progress_records[p].id,
								date:  myDate.getDate() + '/' + (myDate.getMonth() + 1) + '/' + myDate.getFullYear(),
								weight: this.$store.getters.user.meta_data.preferred_units == "metric" ? progress_records[p].value : progress_records[p].imperial_value,
								progress: progress,
								photo: progress_records[p].photo
							};

							this.weight_records.push(record);
						}
					}
        })
      },
      pictureModal(picture){
          this.modal_picture = picture;
      },
		}
	}
</script>

<style scoped>
@media only screen and (min-width: 1px) {
  .progress-table{
	  padding-top: 10px;
	  padding-bottom: 10px;
	  padding-left: 0px !important;
	  padding-right: 0px !important;
  }
}

@media only screen and (min-width: 768px) {
  .progress-table{
	  padding-top: 0px;
	  padding-bottom: 0px;
	  padding-left: 15px !important;
	  padding-right: 15px !important;
  }
}

table{
	border-collapse: collapse;
}

/* table th{
	font-weight: bold;
	text-align:center;
	padding: 15px;
	background: #ddd;
}

table td{
	text-align:center;
	padding: 15px;
	vertical-align: top;
	border: 1px solid #ccc;
} */

table td,
table th {
  text-align: center;
}
table td img {
  height: 100px;
}

.widget {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
}

.trash {
  color: rgba(204, 0, 0, 0.5);
}

.trash:hover {
  color: rgba(204, 0, 0, 1);
}
label {
  text-align: left;
}
.table-wrap {
  border: 1px solid #ccc;
  border-radius: 5px;
}

.weightTitle{
  margin-left: 13px;
}
</style>


// WEBPACK FOOTER //
// src/views/WeightTracking/WeightTracking.vue